export const APP_NAME = 'Trader Journal';
export const APP_LOGO_SRC = '/logo.png';
export const APP_POWERED_BY = 'Powered by Trader Journal';
